import GS from '@/assets/banks/gongshang-bank.svg'
import JS from '@/assets/banks/jianshe-bank.svg'
import ZH from '@/assets/banks/zhonghang-bank.svg'
import NY from '@/assets/banks/nongye-bank.svg'
import YZ from '@/assets/banks/youzheng-bank.svg'
import ZS from '@/assets/banks/zhaoshang-bank.svg'
import JT from '@/assets/banks/jiaotong-bank.svg'
import PF from '@/assets/banks/pufa-bank.svg'
import ZX from '@/assets/banks/zhongxin-bank.svg'
import GD from '@/assets/banks/guangda-bank.svg'
import GF from '@/assets/banks/guangfa-bank.svg'
import HX from '@/assets/banks/huaxia-bank.svg'
import MS from '@/assets/banks/minsheng-bank.svg'
import XY from '@/assets/banks/xingye-bank.svg'
import PA from '@/assets/banks/pingan-bank.svg'
import ZS2 from '@/assets/banks/zheshang-bank.svg'
import HF from '@/assets/banks/hengfeng-bank.svg'
import BH from '@/assets/banks/bohai-bank.svg'
import SH from '@/assets/banks/shanghai-bank.svg'
import BJ from '@/assets/banks/beijing-bank.svg'
import QT from '@/assets/banks/other-card.svg'

import GS_W from '@/assets/bank_bg/gongshang-bank-white.svg'
import JS_W from '@/assets/bank_bg/jianshe-bank-white.svg'
import ZH_W from '@/assets/bank_bg/zhonghang-bank-white.svg'
import NY_W from '@/assets/bank_bg/nongye-bank-white.svg'
import YZ_W from '@/assets/bank_bg/youzheng-bank-white.svg'
import ZS_W from '@/assets/bank_bg/zhaoshang-bank-white.svg'
import JT_W from '@/assets/bank_bg/jiaotong-bank-white.svg'
import PF_W from '@/assets/bank_bg/pufa-bank-white.svg'
import ZX_W from '@/assets/bank_bg/zhongxin-bank-white.svg'
import GD_W from '@/assets/bank_bg/guangda-bank-white.svg'
import GF_W from '@/assets/bank_bg/guangfa-bank-white.svg'
import HX_W from '@/assets/bank_bg/huaxia-bank-white.svg'
import MS_W from '@/assets/bank_bg/minsheng-bank-white.svg'
import XY_W from '@/assets/bank_bg/xingye-bank-white.svg'
import PA_W from '@/assets/bank_bg/pingan-bank-white.svg'
import ZS2_W from '@/assets/bank_bg/zheshang-bank-white.svg'
import HF_W from '@/assets/bank_bg/hengfeng-bank-white.svg'
import BH_W from '@/assets/bank_bg/bohai-bank-white.svg'
import SH_W from '@/assets/bank_bg/shanghai-bank-white.svg'
import BJ_W from '@/assets/bank_bg/beijing-bank-white.svg'
import QT_W from '@/assets/bank_bg/qita-bank-white.svg'



export interface BankConfigItem {
  name: string;
  img: string;
  bg_img: string;
  bg: string;
  disabled?: boolean;
}

interface BankConfig {
  [key: string]: BankConfigItem;
}

export const bankConfig: BankConfig = {
  // --- 国有及全国性股份制银行 ---
  ICBC: {
    name: '工商银行',
    img: GS,
    bg_img: GS_W,
    bg: '#C65255'
  },
  BOC: {
    name: '中国银行',
    img: ZH,
    bg_img: ZH_W,
    bg: '#C65255'
  },
  CCB: {
    name: '建设银行',
    img: JS,
    bg_img: JS_W,
    bg: '#1A66A4'
  },
  PSBC: {
    name: '邮政储蓄银行',
    img: YZ,
    bg_img: YZ_W,
    bg: '#0A806C'
  },
  CITIC: {
    name: '中信银行',
    img: ZX,
    bg_img: ZX_W,
    bg: '#C65255'
  },
  CEB: {
    name: '光大银行',
    img: GD,
    bg_img: GD_W,
    bg: '#713F89'
  },
  HXBANK: {
    name: '华夏银行',
    img: HX,
    bg_img: HX_W,
    bg: '#C65255'
  },
  CMBC: {
    name: '民生银行',
    img: MS,
    bg_img: MS_W,
    bg: '#0A806C'
  },
  SPABANK: {
    name: '平安银行',
    img: PA,
    bg_img: PA_W,
    bg: '#D3904A'
  },
  SPDB: {
    name: '浦发银行',
    img: PF,
    bg_img: PF_W,
    bg: '#1A66A4'
  },
  CZBANK: {
    name: '浙商银行',
    img: ZS2,
    bg_img: ZS2_W,
    bg: '#C65255'
  },
  SHBANK: {
    name: '上海银行',
    img: SH,
    bg_img: SH_W,
    bg: '#D3904A'
  },
  CGB: {
    name: '广发银行',
    img: GF,
    bg_img: GF_W,
    bg: '#C65255'
  },
  COMM: {
    name: '交通银行',
    img: JT,
    bg_img: JT_W,
    bg: '#1A66A4'
  },
  ABC: {
    name: '农业银行',
    img: NY,
    bg_img: NY_W,
    bg: '#0A806C',
    disabled: true // CSV 标注不支持
  },
  CMB: {
    name: '招商银行',
    img: ZS,
    bg_img: ZS_W,
    bg: '#C65255',
    disabled: true // CSV 标注不支持
  },
  BSB: {
    name: '包商银行',
    img: QT,
    bg_img: QT_W,
    bg: '#1A66A4',
    disabled: true // CSV 标注不支持
  },
  CBHB: {
    name: '渤海银行',
    img: BH,
    bg_img: BH_W,
    bg: '#1A66A4'
  },
  NJCB: {
    name: '南京银行',
    img: QT,
    bg_img: QT_W,
    bg: '#1A66A4',
    disabled: true // CSV 标注不支持
  },
  NBBANK: {
    name: '宁波银行',
    img: QT,
    bg_img: QT_W,
    bg: '#1A66A4',
    disabled: true // CSV 标注不支持
  },
  XABANK: {
    name: '西安银行',
    img: QT,
    bg_img: QT_W,
    bg: '#1A66A4',
    disabled: true // CSV 标注不支持
  },
  CIB: {
    name: '兴业银行',
    img: XY,
    bg_img: XY_W,
    bg: '#1A66A4',
    disabled: true // CSV 标注不支持
  },
  
  // --- 地方性商业银行/村镇银行 (使用通用图标) ---
  BJRCB: { name: '北京农商银行', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  FUSHUN: { name: '抚顺银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  LIAOYANG: { name: '辽阳银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  TIBET: { name: '西藏银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  HUIHE: { name: '新疆汇和银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  DLB: { name: '大连银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  FXCB: { name: '阜新银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JLBANK: { name: '吉林银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  NXBANK: { name: '宁夏银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BOJX: { name: '嘉兴银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  CSRCB: { name: '江苏常熟农村商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JNBANK: { name: '江苏江南农村商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JRCB: { name: '江苏江阴农村商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  CJCCB: { name: '江苏长江商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JHBANK: { name: '金华银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  TZCB: { name: '台州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  WZCB: { name: '温州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  CZCB: { name: '浙江稠州商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SZRCB: { name: '江苏苏州农村商业银行有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  NBCBANK: { name: '宁波通商银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SXCB: { name: '绍兴银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  WZMS: { name: '温州民商银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  MTBANK: { name: '浙江民泰商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  TLBANK: { name: '浙江泰隆商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  FUBON: { name: '富邦华一银行有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  DBS: { name: '星展银行（中国）有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  NCB: { name: '南洋商业银行（中国）有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  GYCB: { name: '贵阳银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  HANABANK: { name: '韩亚银行（中国）有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  YBCCB: { name: '宜宾市商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  LSCCB: { name: '乐山市商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  XW_BANK: { name: '四川新网银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  ZGCCB: { name: '自贡银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SDEB: { name: '广东顺德农村商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  HKBC: { name: '海口联合农村商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  GLBANK: { name: '桂林银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  ZGCBANK: { name: '北京中关村银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BOCD: { name: '承德银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  FDB: { name: '富滇银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  HSBK: { name: '衡水银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  KLB: { name: '昆仑银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SHINHAN: { name: '新韩银行（中国）有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  XTB: { name: '邢台银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  HTBANK: { name: '云南红塔银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  ZJKCCB: { name: '张家口银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BOCY: { name: '沧州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  LZYH: { name: '兰州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  WOORI: { name: '友利银行（中国）有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JZCTB: { name: '焦作中旅银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BOP: { name: '平顶山银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BOQZ: { name: '泉州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  XIB: { name: '厦门国际银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  XYVB: { name: '长葛轩辕村镇银行', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  ONEBANK: { name: '福建华通银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  DTBANK: { name: '大同银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JZBANK: { name: '晋中银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  YQCCB: { name: '阳泉市商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  YCRX: { name: '榆次融信村镇银行', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BOYK: { name: '营口银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BODD: { name: '丹东银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SNCCB: { name: '遂宁银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  GSBANK: { name: '甘肃银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  ZZBANK: { name: '郑州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  ZYBANK: { name: '中原银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BGB: { name: '广西北部湾银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  FJHXBC: { name: '福建海峡银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SZSBK: { name: '石嘴山银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  YILIAN: { name: '吉林亿联银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SJBANK: { name: '盛京银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  TIE_LING: { name: '铁岭银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  CCW_BANK: { name: '长城华西银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  HAINAN_BANK: { name: '海南银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  HBC: { name: '湖北银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  QHDBANK: { name: '秦皇岛银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  KCB: { name: '天津金城银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  GZBANK: { name: '赣州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SANXIANG: { name: '湖南三湘银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SHRB: { name: '上海华瑞银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  SRBANK: { name: '上饶银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JINCHB: { name: '晋城银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  CHANGZHI: { name: '长治银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  YKYH: { name: '营口沿海银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  CYBANK: { name: '朝阳银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  PZHCCB: { name: '攀枝花市商业银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  FMBANK: { name: '重庆富民银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  CCQTGB: { name: '重庆三峡银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  GCB: { name: '广州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JXBANK: { name: '江西银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  DAQINGB: { name: '龙江银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  HRBANK: { name: '哈尔滨银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BGZ: { name: '贵州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  JJBANK: { name: '九江银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  BOJZ: { name: '锦州银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  CSCB: { name: '长沙银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
  GHB: { name: '广东华兴银行股份有限公司', img: QT, bg_img: QT_W, bg: '#1A66A4' },
}

export const getBankConfig = (bankCode: string) => {
  if (!bankCode || !bankConfig[bankCode]) {
    return {
      name: '其他银行',
      img: QT,
      bg_img: QT_W,
      bg: '#1A66A4'
    }
  }
  return bankConfig[bankCode]
}